import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.667 14.667V7.334M12.667 4.667V1.334M8 14.667v-3.333M8 8.667V1.334M3.333 14.667V7.334M3.333 4.667V1.334M2 7.333h2.667M11.333 7.333H14M6.667 8.666h2.666"
    />
  </svg>
)
export default SvgComponent
